<div class="card-container">

  <div class="dashboardLocal">
    <div class="localSelect">
      <kendo-dropdownlist kendoDropDownFilter textField="nome" [data]="listItemsLocais" #refLocal valueField="id"
        [defaultItem]="placeHolder" (selectionChange)="selectionChange($event)">
      </kendo-dropdownlist>
    </div>
  </div>

  <div class="card-component">
    <kendo-tilelayout [columns]="6" [rowHeight]="200" [resizable]="true" [reorderable]="true">

      <!-- Visão Geral -->
      <kendo-tilelayout-item [title]="customMsgService.translate('visaoGeral')" [col]="1" [colSpan]="2">
        <kendo-tilelayout-item-body>
          <h3>{{customMsgService.translate('armarios')}}: {{ data.numeroArmarios }}</h3>
          <h3>{{customMsgService.translate('teams')}}: {{ data.numeroEquipas }}</h3>
          <h3> {{customMsgService.translate('users')}}: {{ data.numeroUtilizadores }}</h3>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <!-- Artigos e Centros de Custo -->
      <kendo-tilelayout-item [title]="customMsgService.translate('alocasaoDeRecursos') " [col]="3" [colSpan]="2">
        <kendo-tilelayout-item-body>
          <h3>{{ customMsgService.translate('centrosDeCusto') }}: {{ data.numeroCentrosDeCusto }}</h3>
          <h3>{{customMsgService.translate('artigos')}}: {{ data.numeroArtigos }}</h3>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <!-- Cacifos -->
      <kendo-tilelayout-item [title]="customMsgService.translate('outrosIndicadores')" [col]="5" [colSpan]="2">
        <kendo-tilelayout-item-body>
          <h3>{{ customMsgService.translate('cacifosComStockBaixo') }}: {{ data.numeroCacifosStockBaixo }}</h3>
          <h3>{{ customMsgService.translate('cacifosComAnomalia') }}: {{ data.numeroCacifosComAnomalia }}</h3>
          <h3>{{ customMsgService.translate('cacifosInibidos') }}: {{ data.numeroCacifosInibidos }}</h3>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

    </kendo-tilelayout>

  </div>
</div>